import fieldRequired from './fieldRequired';

const fieldRequiredCustom = (message) => (value) => {
  if (fieldRequired(value)) {
    return message;
  }
};

export default fieldRequiredCustom;
